var map = {
	"./profile-create.svg": 1193,
	"./request-complete.svg": 1194,
	"./request-delivered.svg": 1195,
	"./request-started.svg": 1196,
	"./review.svg": 1197,
	"./submit-requirement.svg": 1198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1192;